module.exports = __webpack_public_path__ + "pic_bizny_web_02-640@2x.png?9a0204447a71cb220da90bbe4690c8e3";